var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-narrow" }, [
        _c(
          "h2",
          {
            staticClass:
              "subtitle has-text-weight-bold has-text-primary is-size-4"
          },
          [
            _vm._v(
              "\n        Volumes (" +
                _vm._s(_vm.fields.volumes.length) +
                ")\n      "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttons has-addons" },
        [
          _c("sc-button", {
            attrs: { theme: "primary", text: "Adicionar volume" },
            on: { click: _vm.addVolume }
          }),
          _vm._v(" "),
          _c("sc-button", {
            attrs: {
              disabled: _vm.fields.volumes.length === 1,
              theme: "default",
              text: "Limpar volumes"
            },
            on: {
              click: function($event) {
                _vm.cleanVolumes(_vm.fields.volumes.length)
              }
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sc-volume_scroll" }, [
      _c(
        "div",
        { staticClass: "columns is-multiline" },
        _vm._l(_vm.fields.volumes, function(volume, volumeKey) {
          return _c(
            "div",
            { key: volumeKey, staticClass: "column is-4" },
            [
              _c(
                "sc-card",
                [
                  _c(
                    "template",
                    {
                      staticClass: "columns",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("div", { staticClass: "column is-5" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "has-text-primary is-size-10 card-header-title"
                          },
                          [
                            _vm._v(
                              "\n                Volume " +
                                _vm._s(volumeKey + 1) +
                                "\n              "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "sc-volume_header column is-6 has-addons"
                        },
                        [
                          _c(
                            "sc-field",
                            [
                              _c("sc-button", {
                                attrs: {
                                  disabled: volumeKey === 0,
                                  theme: "danger",
                                  size: "small",
                                  text: "Deletar"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.deletVolume(volumeKey)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("sc-button", {
                                attrs: {
                                  theme: "info",
                                  size: "small",
                                  text: "Replicar"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.replicateVolume(volume)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "sc-field",
                                {
                                  attrs: {
                                    prop:
                                      "volumes." + volumeKey + ".replicateQtd"
                                  }
                                },
                                [
                                  _c("sc-input", {
                                    attrs: {
                                      type: "number",
                                      min: "1",
                                      size: "is-small"
                                    },
                                    model: {
                                      value: volume.replicateQtd,
                                      callback: function($$v) {
                                        _vm.$set(volume, "replicateQtd", $$v)
                                      },
                                      expression: "volume.replicateQtd"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("template", { attrs: { slot: "body" }, slot: "body" }, [
                    _c("div", { staticClass: "columns" }, [
                      _c(
                        "div",
                        { staticClass: "column is-5" },
                        [
                          _c(
                            "sc-field",
                            {
                              attrs: {
                                label: "Peso",
                                prop: "volumes." + volumeKey + ".weight"
                              }
                            },
                            [
                              _c("sc-decimal", {
                                attrs: { suffix: "kg", precision: 2 },
                                model: {
                                  value: volume.weight,
                                  callback: function($$v) {
                                    _vm.$set(volume, "weight", $$v)
                                  },
                                  expression: "volume.weight"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-field",
                            {
                              attrs: {
                                label: "Altura",
                                prop: "volumes." + volumeKey + ".height"
                              }
                            },
                            [
                              _c("sc-decimal", {
                                attrs: { suffix: "cm", precision: 2 },
                                model: {
                                  value: volume.height,
                                  callback: function($$v) {
                                    _vm.$set(volume, "height", $$v)
                                  },
                                  expression: "volume.height"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-field",
                            {
                              attrs: {
                                label: "Valor Nota Fiscal",
                                prop: "volumes." + volumeKey + ".cost_of_goods"
                              }
                            },
                            [
                              _c("sc-input-currency", {
                                model: {
                                  value: volume.cost_of_goods,
                                  callback: function($$v) {
                                    _vm.$set(volume, "cost_of_goods", $$v)
                                  },
                                  expression: "volume.cost_of_goods"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "column is-5" },
                        [
                          _c(
                            "sc-field",
                            {
                              attrs: {
                                label: "Comprimento",
                                prop: "volumes." + volumeKey + ".length"
                              }
                            },
                            [
                              _c("sc-decimal", {
                                attrs: { suffix: "cm", precision: 2 },
                                model: {
                                  value: volume.length,
                                  callback: function($$v) {
                                    _vm.$set(volume, "length", $$v)
                                  },
                                  expression: "volume.length"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-field",
                            {
                              attrs: {
                                label: "Largura",
                                prop: "volumes." + volumeKey + ".width"
                              }
                            },
                            [
                              _c("sc-decimal", {
                                attrs: { suffix: "cm", precision: 2 },
                                model: {
                                  value: volume.width,
                                  callback: function($$v) {
                                    _vm.$set(volume, "width", $$v)
                                  },
                                  expression: "volume.width"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                2
              )
            ],
            1
          )
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16d391ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16d391ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-volume/ScVolume.vue
// module id = null
// module chunks = 